import { useState } from 'react'
import { ModalConfirmation } from './ModalConfirmation'
import { MdOutlineCropRotate } from "react-icons/md";
import { BsArrowReturnLeft } from "react-icons/bs";
import { LuCheck } from "react-icons/lu";
import { RotateImage } from './RotateImage';
import { ImageType } from '../../interfaces/intakes.reports';
import { useRotateImage } from '../../api/useEditImages';
import { SpinnerCustom } from './SpinnerCustom';

interface Props {
    closeModal: () => void
    deleteImage: (image: ImageType) => Promise<void>
    images: ImageType[]
    index: number
    reportId?: string
}

export const Carousel = ({ closeModal, deleteImage, images, index, reportId }: Props) => {

    const { mutate, isLoading: isRotating } = useRotateImage()

    const [confirmation, setConfirmation] = useState(false)
    const [currentIndex, setCurrentIndex] = useState(index)
    const [isLoading, setIsLoading] = useState(false)
    const [openRotate, setOpenRotate] = useState(false)

    // Imagen rotada
    const [imageRotated, setImageRotated] = useState<File>(new File([], ""))


    const handleNext = () => {
        if (currentIndex < images.length - 1) {
            setCurrentIndex(currentIndex + 1)
        } else {
            setCurrentIndex(0)
        }
    }

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        } else {
            setCurrentIndex(images.length - 1)
        }
    }

    const removingImage = async (image: ImageType) => {
        setIsLoading(true)
        try {
            await deleteImage(image)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
            setConfirmation(false)
            closeModal()
        }

    };

    const sendRotatedImage = () => {
        
        if(!reportId) return;

        mutate({
            newImage: imageRotated,
            oldImage: images[currentIndex],
            reportId
        }, {
            onSuccess: () => {
                setOpenRotate(false)
            }
        })
    };

    return (
        <div className="model open">

            {
                confirmation &&
                <ModalConfirmation
                    action={() => removingImage(images[currentIndex])}
                    closeConfirmation={setConfirmation}
                    msg="Delete this Image?"
                    buttonName='Delete'
                    isLoading={ isLoading }
                />
            }

            <div className='flex tw-fixed tw-left-[1.5rem] tw-top-[1rem]'>

                {
                    !openRotate &&
                    <button
                        onClick={() => setConfirmation(true)}
                        className="tw-bg-red-600 tw-rounded-full tw-text-white tw-px-4 tw-h-9 tw-mr-3 shadow">Delete
                    </button>
                }

                <button
                    onClick={() => { !openRotate ? setOpenRotate(true) : setOpenRotate(false) }}
                    className="tw-bg-slate-300 tw-h-100 tw-aspect-square tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-full">
                    {
                        !openRotate
                            ? <MdOutlineCropRotate size={20} />
                            : <BsArrowReturnLeft size={20} />
                    }
                </button>

                {
                    openRotate &&
                    <button id="send-rotated-image"
                        onClick={() => { !openRotate ? setOpenRotate(true) : sendRotatedImage() }}
                        className="tw-bg-green-600 tw-h-100 tw-aspect-square tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-ml-3">
                            {
                                isRotating
                                ? <SpinnerCustom center size="xxs" color="white"/> 
                                : <LuCheck size={20} color="white" />
                            }
                    </button>
                }
            </div>

            {
                openRotate
                    ? <RotateImage image={images[currentIndex]} onRotateEnd={(file) => setImageRotated(file)} />
                    : <>

                        {
                            images.length > 0 &&
                            images.map((image, index) => {
                                if (index === currentIndex) return (<img key={image.key} src={image.imgURL || image.imgURL_low} alt="stageImg" />)
                                else return null
                            })
                        }
                        <div className="next-prev">
                            <img src="/assets/img/image-prev.svg" alt="imageprev" width={10} onClick={() => handlePrev()} />
                            <img src="/assets/img/image-next.svg" alt="imagenext" width={10} onClick={() => handleNext()} />
                        </div>

                        <div className="index-float">
                            <p className='font-normal'>{currentIndex + 1} / {images.length}</p>
                        </div>
                    </>
            }


            <button>
                <img
                    className="svg-icon"
                    src="/assets/img/close-icon.svg"
                    alt="close-icon"
                    width={10}
                    onClick={() => {
                        closeModal()
                    }}
                />
            </button>




        </div>
    )
}
